import SideBar from "./SideBar";
import Context from "../../../context";
import { useContext, useEffect } from "react";
import { useHistory } from "react-router";

export default function Layout({ children }) {
  const { contextState, setContextState } = useContext(Context);

  const history = useHistory();

  useEffect(() => {
    if (
      contextState.currentAccount === null ||
      contextState.currentAccount === undefined
    ) {
      history.push("/");
      window.location.reload(false);
    }
  }, [contextState.currentAccount]);

  return (
    <div className="layout">
      <SideBar />
      {children}
    </div>
  );
}
